import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Divider, Typography } from '@mui/material';
import Food from '@components/offer/models/Food';
import _ from 'lodash';
import FoodPriceListItem from './FoodPriceListItem';
import RestaurantOfferStore from '@components/offer/stores/RestaurantOfferStore';

interface FoodPriceListProps {
    restaurantOfferStore: RestaurantOfferStore;
}

const FoodPriceList: React.FC<FoodPriceListProps> = observer(({ restaurantOfferStore }) => {
    const { orderFoodRequest, onFoodPriceClick } = restaurantOfferStore;

    if (orderFoodRequest.food.foodPrices.length === 1) {
        return null;
    }

    return (
        <Box mb={2}>
            <Typography
                variant='subtitle2'
                fontWeight={600}>
                Porcija
            </Typography>
            {/* <Divider
                sx={{ mb: 1.5 }}
                textAlign="left">
                <Typography variant='caption' color={"GrayText"}>
                    Porcija
                </Typography>
            </Divider> */}
            <Box mt={1} display={"flex"} justifyContent={"center"} gap={2}>
                {_.map(orderFoodRequest.food.foodPrices, (foodPrice) => (
                    <FoodPriceListItem
                        key={foodPrice.id}
                        foodPrice={foodPrice}
                        onClick={onFoodPriceClick} />
                ))}
            </Box>
        </Box>
    )
})

export default FoodPriceList;